import z from 'zod';
import { ERROR_MESSAGES } from '~/constants';
import { optionSchemaRequired } from '~/features/types';

// [MCV-1547] Every figure here is a rate or a volume, so none of them can be
// negative. The bound backs up the input-level guard in TextInput for values
// that never pass through a keystroke (paste, autofill, an edited draft).
export const CompensationFormSchema = z
  .object({
    id: z.number().optional(),
    msaasListingId: z.number().optional(),
    compType: optionSchemaRequired,
    pricePerHour: z.preprocess(
      (arg) => (arg === null || arg === '' || arg === undefined ? null : Number(arg)),
      z.number().min(0, ERROR_MESSAGES.NON_NEGATIVE_INT).optional().nullable()
    ),
    pricePerShift: z.preprocess(
      (arg) => (arg === null || arg === '' || arg === undefined ? null : Number(arg)),
      z.number().min(0, ERROR_MESSAGES.NON_NEGATIVE_INT).optional().nullable()
    ),
    pricePerRvu: z.preprocess(
      (arg) => (arg === null || arg === '' || arg === undefined ? null : Number(arg)),
      z.number().min(0, ERROR_MESSAGES.NON_NEGATIVE_INT).optional().nullable()
    ),
    yearlyRvusPerFte: z.preprocess(
      (arg) => (arg === null || arg === '' || arg === undefined ? null : Number(arg)),
      z.number().min(0, ERROR_MESSAGES.NON_NEGATIVE_INT).optional().nullable()
    ),
  })
  .refine(
    (schema) => {
      if (schema.compType.value === 'HOUR') {
        return schema.pricePerHour !== undefined && schema.pricePerHour !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['pricePerHour'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'SHIFT') {
        return schema.pricePerShift !== undefined && schema.pricePerShift !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['pricePerShift'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'RVU') {
        return schema.pricePerRvu !== undefined && schema.pricePerRvu !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['pricePerRvu'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'RVU') {
        return schema.yearlyRvusPerFte !== undefined && schema.yearlyRvusPerFte !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['yearlyRvusPerFte'],
    }
  );
export type CompensationFormValues = z.infer<typeof CompensationFormSchema>;
